import { app } from '../../../../app';
import { Controller } from './paypal-cancelled.controller';

app.component('companySmsServicesPaypalCancelled', {
    controller: Controller,
    templateUrl: require('./paypal-cancelled.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/paypal-cancelled/paypal-cancelled.component.js